<template>
  <div class="wrapper">
    <div class="page-header">
      <div>
        <img src="../image/logo/sys-logo.png" />
        <p>芭田追溯管理平台</p>
        <!-- <span @click="goIndex">返回首页</span> -->
      </div>
    </div>
    <div class="find">
      <div class="first">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="手机号" prop="telphone">
            <el-input
              v-model="ruleForm.telphone"
              placeholder="请输入手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="phoneCode">
            <el-input
              v-model="ruleForm.phoneCode"
              placeholder="请输入验证码"
              max="6"
            ></el-input>
            <div
              class="phoneCode"
              v-show="showCode"
              @click="goCode(ruleForm.telphone)"
            >
              发送验证码
            </div>
            <div class="phoneCode" v-show="!showCode">{{ count }}s</div>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              placeholder="请输入新密码"
              oninput="value=value.replace(/[\ ]/,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              placeholder="请再次输入新密码"
              oninput="value=value.replace(/[\ ]/,'')"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button type="primary" @click="next('ruleForm')"
              >确&nbsp;&nbsp;&nbsp;认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateUserPassword,
  validateTelphoneCode,
  sendCode,
} from "@/common/api.js"; // 8100 3200
export default {
  components: {},
  props: {},
  data() {
    return {
      ruleForm: {
        telphone: "",
        phoneCode: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        telphone: [
          {
            validator: this.validatePhone,
            required: true,
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            validator: this.validatePhoneCode,
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            validator: this.validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            validator: this.validatePass2,
            trigger: "blur",
          },
        ],
      },
      showCode: true,
      count: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      if (value) {
        var checkRule = /^1[3456789]\d{9}$/;
        var telphone = checkRule.test(value);
        if (!telphone) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      }
    },
    validatePhoneCode(rule, value, callback) {
      if (value == "") {
        callback(new Error("请输入手机验证码"));
      }
      if (value) {
        var params = {
          telphone: this.ruleForm.telphone,
          smsCode: value,
        };
        validateTelphoneCode(params).then((res) => {
          if (res.errorCode != 200) {
            callback(new Error(res.msg));
          } else {
            callback();
          }
        });
      }
    },
    validatePass(rule, value, callback) {
      if (value) {
        if (value.length > 20 || value.length < 6) {
          callback(new Error("请输入6~20位密码"));
        }
        callback();
      } else {
        callback(new Error("请输入前密码"));
      }
    },
    validatePass2(rule, value, callback) {
      if (value) {
        if (value !== this.ruleForm.pass) {
          callback(new Error("两次输入密码不一致!"));
        }
        callback();
      } else {
        callback(new Error("请重复输入新密码"));
      }
    },
    goCode(phone) {
      if (phone == "" || !/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("手机号错误");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      if (phone) {
        sendCode(phone).then((res) => {
          if (res.errorCode != 200) {
            this.$message.error("验证码发送失败");
          }
        });
      }
    },
    next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = {
            telphone: this.ruleForm.telphone,
            password: this.ruleForm.pass,
            confirmPassword: this.ruleForm.pass,
          };
          updateUserPassword(params).then((res) => {
            if (res.errorCode == 200) {
              this.$confirm("修改成功, 请重新登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push({
                    path: "/login",
                  });
                })
                .catch(() => {
                  this.$router.push({
                    path: "/login",
                  });
                });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  overflow: hidden;
  .page-header {
    height: 90px;
    background-color: #ffffff;
    div {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      line-height: 90px;
      img {
        vertical-align: top;
        height: 60px;
        margin-top: 15px;
      }
      p {
        height: 90px;
        line-height: 90px;
        font-size: 40px;
        flex-grow: 1;
        text-align: center;
      }
      span {
        font-size: 16px;
        color: #1492ff;
        cursor: pointer;
      }
    }
  }
  .find {
    width: 1300px;
    margin: 80px auto;
    .first {
      width: 400px;
      margin: auto;
      .phoneCode {
        position: absolute;
        right: -4px;
        top: 0;
        width: 100px;
        height: 40px;
        background: #409eff;
        color: #fff;
        border-radius: 2px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
    }
  }
  .footer {
    margin-top: 14%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/forgetPassword.vue